import React from 'react'

import { getEntity, getHeaderData, getFooterData } from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeArchiveDocuments } from '@models/ArchiveDocuments'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import normalizeMetadata from '@models/Metadata'

import { Col, Container, Row } from '@/atoms/Grid'
import Breadcrumb from '@/molecules/Breadcrumb'
import { ArchiveList, ArchiveSidebar } from '@/organisms'

import Layout from '@/organisms/Layout'

export const getStaticProps = async ({ params }) => {
  const [header, footer, documents] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getEntity({ entity: 'documents' }),
  ])

  return {
    props: {
      metadata: normalizeMetadata(documents.data.seo),
      breadcrumb: normalizeBreadcrumb([{ label: 'Set informativi' }]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveDocuments(documents.data),
    },
  }
}

const ArchiveDocuments = ({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='set-informativi'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList
              {...content.list}
              entity='set-informativi'
              ctaLabel='Archivio'
              listSlice={6}
              minimizedList
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default ArchiveDocuments
